<div>
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-col-12">
      <label class="label-large-bold">Sub - Task type</label>
      <div><b>I-140</b></div>
    </div>
  </div>
  <div class="p-grid dashed-line p-my-4"></div>
  <div [formGroup]="i140TaskForm">

     <!-- Hide section IMGLT-568 -->
    <!-- <div class="p-fluid p-formgrid p-grid">
      <div class="p-col-12">
        <label class="label-large-bold">Processing Information</label>
      </div>
      <div class="p-col-4">
        <label for="tasktype" class="required">Processing Type</label>
        <div class="p-formgroup-inline">
          <div class="p-field-checkbox">
            <p-radioButton name="processingType" value="regular" (onClick)="onChangeProcessingType()"
              formControlName="processingType" inputId="regular"></p-radioButton>
            <label for="regular">Regular</label>
          </div>
          <div class="p-field-checkbox">
            <p-radioButton name="processingType" value="premium" (onClick)="onChangeProcessingType()"
              formControlName="processingType" inputId="premium"></p-radioButton>
            <label for="premium">Premium</label>
          </div>
        </div>
        <span class="invalid-message"
          *ngIf="i140TaskForm.get('processingType').touched && i140TaskForm.get('processingType').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="p-col-4">
        <div *ngIf="taskId">
          <label class="mt-2" *ngIf="!isOutsideImagility && oldServiceCenterName">Old Service center name</label>
          <div class="p-grid pl-2" *ngIf="!isOutsideImagility">
            {{oldServiceCenterName}}
          </div>
        </div>
        <label for="tasktype" class="required">Select service center</label>
        <p-dropdown [options]="serviceCenters" formControlName="serviceCenterId" name="serviceCenterId"
          optionLabel="name" optionValue="id" placeholder="Select Service center">
        </p-dropdown>
        <span class="invalid-message"
          *ngIf="i140TaskForm.get('serviceCenterId').touched && i140TaskForm.get('serviceCenterId').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
    </div> -->

    <div class="p-grid ml-2 mt-3" *ngIf="taskId">Was the case transferred to the selected service center <span
        class="pl-3">
        <mat-slide-toggle color="primary" name="isCaseTransferred" formControlName="isCaseTransferred">
        </mat-slide-toggle>
      </span></div>
    <div class="p-grid dashed-line p-my-4"></div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-col-12">
        <label class="label-large-bold">Who will be the signatory for this task / petition</label>
      </div>
      <div class="p-col-4">
        <label for="tasktype" class="required">Signatory Name</label>

        <p-dropdown [options]="reviewUsersList" formControlName="authorizedSignatoryId" name="authorizedSignatoryId"
          optionLabel="firstName" optionValue="id" placeholder="Select Signatory" (onChange)="userSelected()">

          <ng-template pTemplate="selectedItem">
            <div *ngIf="selectedSignatory">
              <div>{{selectedSignatory?.firstName +' '+selectedSignatory?.lastName}}</div>

            </div>
          </ng-template>
          <ng-template let-employee pTemplate="item">
            <div>
              <div>{{employee?.firstName +' '+employee?.lastName}}</div>
            </div>
          </ng-template>
        </p-dropdown>
        <span class="invalid-message"
          *ngIf="i140TaskForm.get('authorizedSignatoryId').touched && i140TaskForm.get('authorizedSignatoryId').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="p-col-4">
        <label for="designation">Designation</label>
        <input type="text" readOnly name="selectedDesignation" class="form-control txt-comp"
          formControlName="selectedDesignation" />
      </div>

    </div>
    <div class="p-grid dashed-line p-my-4"></div>
    <div *ngIf="isAttorneySelect">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-col-12">
          <label class="label-large-bold">Lawfirm Information</label>
        </div>
        <div class="p-col-4">
          <!-- <div class="taskId">
            <label class="mt-2 label-cls" *ngIf="!isOutsideImagility">Old Attorney firm</label>
            <div class="row" *ngIf="!isOutsideImagility">
              {{oldAttorneyCompanyName}}
            </div>
          </div> -->
          <label for="attorneys">Lawfirm</label>

          <p-dropdown [options]="attorneys" formControlName="attorneyId" name="attorneyId" optionLabel="attorneyName"
            optionValue="attorneyId" (onChange)="attorneySelected()" placeholder="Select lawfirm">
          </p-dropdown>
          <!-- <span class="invalid-message" *ngIf="i140TaskForm.get('attorneyId').touched && i140TaskForm.get('attorneyId').errors?.required">
        {{ getGlobalErrorMessages("REQUIRED") }}
        </span> -->
        </div>
        <div class="p-col-4">
          <!-- <div *ngIf="taskId">
            <label class="mt-2 label-cls" *ngIf="!isOutsideImagility">Old Preparer Name</label>
            <div class="row" *ngIf="!isOutsideImagility">
              {{oldPreparerAttorneyName}}
            </div>

          </div> -->
          <label for="designation">Preparer Name</label>
          <p-dropdown [options]="attorneyUsers" formControlName="preparerAttorneyId" name="preparerAttorneyId"
            optionLabel="firstName" optionValue="id" placeholder="Select Preparer" (onChange)="userPreparerSelected()">

            <ng-template pTemplate="selectedItem">
              <div *ngIf="selectedPreparer">
                <div>{{selectedPreparer?.firstName +' '+selectedPreparer?.lastName}}</div>

              </div>
            </ng-template>
            <ng-template let-employee pTemplate="item">
              <div>
                <div>{{employee?.firstName +' '+employee?.lastName}}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <!-- <span class="invalid-message" *ngIf="i140TaskForm.get('preparerAttorneyId').touched && i140TaskForm.get('preparerAttorneyId').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
          </span> -->
        </div>

      </div>
      <!-- <div class="p-grid p-ml-2 mt-3" *ngIf="taskId && !isOutsideImagility">Is this the same Attorney who filled the petition?
    <span class="pl-3"><mat-slide-toggle color="primary" name="isAttorneySame" formControlName="isAttorneySame" ></mat-slide-toggle></span></div> -->
    </div>
    <div *ngIf="!isAttorneySelect">
      <h5 class="labelText">Lawfirm Details </h5>
      <div class="p-grid">
        <div class="p-col-4 pl-0">
          <label class="mt-2 ml-2 label-cls">Firm Name</label>
          <div class="row mt-1 ml-2">
            {{employeeDetails?.companyName}}
          </div>
        </div>
        <div class="p-col-4">
          <!-- <label class="mt-2 ml-2 label-cls">Preparer Name</label>
          <div class="row mt-1 ml-2">
            {{employeeDetails?.firstName +' '+employeeDetails?.lastName}}
          </div> -->
          <label class="mt-2 d-block create-task-label">Law Firm Users</label>
          <p-multiSelect class="w-100" optionValue="id" [options]="lawFirmUsersList"
            formControlName="lawFirmUsers" appendTo="body" defaultLabel="Select" optionLabel="firstName" (onChange)="usersLawFrimSelected()">
              <ng-template pTemplate="selectedItems">
                <div *ngIf="selectedLawFirmUsers.length">{{selectedLawFirmUsersTextArr.join(', ')}}</div>
                <div *ngIf="!selectedLawFirmUsers.length">Select</div>
              </ng-template>
              <ng-template let-employee pTemplate="item">
                <div>{{employee?.firstName +' '+employee?.lastName}}</div>
              </ng-template>
            </p-multiSelect>
        </div>
      </div>
    </div>



    <div class="p-grid dashed-line p-my-4"></div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-col-12">
        <label class="label-large-bold">Petitioner Information</label>
      </div>
      <div class="p-col-4">
        <label for="attorneys" class="required">Petitioner preparer name</label>


        <p-dropdown [options]="users" formControlName="immSpecialistId" name="immSpecialistId" optionLabel="firstName"
          optionValue="id" placeholder="Select Petitioner Preparer" (onChange)="onPetitionerPreparerSelected()" appendTo="body">

          <ng-template pTemplate="selectedItem">
            <div *ngIf="selectedPetitionPreparer">
              <div>{{selectedPetitionPreparer?.firstName +' '+selectedPetitionPreparer?.lastName}}</div>

            </div>
          </ng-template>
          <ng-template let-employee pTemplate="item">
            <div>
              <div>{{employee?.firstName +' '+employee?.lastName}}</div>
            </div>
          </ng-template>
        </p-dropdown>
        <span class="invalid-message"
          *ngIf="i140TaskForm.get('immSpecialistId').touched && i140TaskForm.get('immSpecialistId').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
    </div>

  </div>
</div>
